import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=2addb40f&scoped=true"
import script from "./InfoIcon.vue?vue&type=script&lang=js"
export * from "./InfoIcon.vue?vue&type=script&lang=js"
import style0 from "./InfoIcon.vue?vue&type=style&index=0&id=2addb40f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2addb40f",
  null
  
)

export default component.exports